import axios from "axios";
import axiosUtil from "@plannel/utils/axios-bigint";
import authService from "@plannel/services/system/auth-service";
import { getAgentLanguage } from "@plannel/utils/i18n";

/**
 * AgentCore Runtime 채팅 서비스
 * POST /api/chat → AgentChatController → AgentCoreService → AWS AgentCore Runtime
 */

const createChatInstance = () => {
  const user = authService.getCurrentUser();
  return axios.create({
    headers: user && user.accessToken
      ? {
          "Content-type": "application/json",
          "x-tenant-id": user.tenantId,
          Authorization: `${user.type} ${user.accessToken}`,
        }
      : { "Content-type": "application/json" },
    transformResponse: axiosUtil.transformResponse,
    transformRequest: axiosUtil.transformRequest,
    timeout: 120000, // 2분 (AgentCore 응답 대기)
  });
};

/**
 * 채팅 메시지 전송
 * @param {string} prompt - 사용자 질문
 * @param {string} pageId - 현재 화면 viewName (예: "reviewBaseline")
 * @param {string|undefined} sessionId - 멀티턴 세션 ID (없으면 서버에서 생성)
 * @param {Object|undefined} pageContext - 화면 컨텍스트 (filters, gridData, chartData 등)
 * @param {"analyze"|"chat"} mode - 실행 모드 (자동분석: analyze, 자유질문: chat)
 * @returns {Promise<{answer: string, sessionId: string, pageId: string, metadata: object}>}
 */
const sendMessage = (prompt, pageId, sessionId, pageContext, mode = "chat") => {
  const user = authService.getCurrentUser();
  const language = getAgentLanguage();
  return createChatInstance().post("/api/chat", {
    prompt,
    pageId:            pageId ?? "",
    sessionId:         sessionId ?? null,
    tenantId:          user?.tenantId ?? "",
    userId:            user?.username ?? "",
    useKb:             true,
    useMemory:         true,
    enablePromptCache: true,
    pageContext:       pageContext ?? null,
    mode,
    language,
  });
};

const chatService = { sendMessage };
export default chatService;

